import { Grid, Typography } from '@mui/material'
import React from 'react'
import { BulkActionResult } from 'src/viewModels/workflow/BulkActionResult'

interface IBulkActionResultDisplayProps {
  results: Array<BulkActionResult>
}

// Define the functional component
const BulkActionResultDisplay: React.FC<IBulkActionResultDisplayProps> = ({
  results,
}) => {
  let totalCount = results.length
  let passedItems = results.filter((x) => x.errorMessage === undefined)
  let failedItems = results.filter((x) => x.errorMessage !== undefined)

  let message = ''

  if (passedItems.length === totalCount) {
    message = `All ${totalCount} items were processed successfully`
  } else if (failedItems.length === totalCount) {
    message = `All ${totalCount} items failed to process`
  } else {
    message = `${passedItems.length} of ${totalCount} processed successfully.`
  }

  return (
    <Grid container direction="column" spacing={2} sx={{ p: 2 }}>
      <Grid item>
        <Typography
          variant="subtitle1"
          color={failedItems.length === totalCount ? 'error' : 'primary'}
        >
          <strong>{message}</strong>
        </Typography>
      </Grid>

      {failedItems.length > 0 && (
        <Grid item>
          <Typography variant="subtitle1" color="error" sx={{ mb: 1 }}>
            <strong>ERRORS</strong>
          </Typography>
          <ul style={{ color: 'red', margin: 0, paddingLeft: '1.5rem' }}>
            {failedItems.map((error, index) => (
              <li key={index}>
                {`${error.externalItemIdentifier} - ${error.errorMessage}`}
              </li>
            ))}
          </ul>
        </Grid>
      )}
    </Grid>
  )
}

export default BulkActionResultDisplay
